import { render, staticRenderFns } from "./HubPagination.vue?vue&type=template&id=60c69af7&scoped=true&"
import script from "./HubPagination.vue?vue&type=script&lang=ts&"
export * from "./HubPagination.vue?vue&type=script&lang=ts&"
import style0 from "./HubPagination.vue?vue&type=style&index=0&id=60c69af7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c69af7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
